import isEmpty from 'lodash/isEmpty';
import { fireStore } from '../firebase';

export const getDocs = async ({ filter }) => {
  let docRef = fireStore.collection('buzzs');
  
  if (filter) {
    if (!isEmpty(filter.brand)) {
      docRef = docRef.where('brand', '==', filter.brand);
    }

    if (!isEmpty(filter.industry)) {
      docRef = docRef.where('industry', '==', filter.industry);
    }

    if (!isEmpty(filter.category)) {
      docRef = docRef.where('category', '==', filter.category);
    }
  }
  
  docRef = docRef.orderBy('created_at', 'desc').orderBy('index', 'asc');

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('buzzs').add(data);
}

export const updateDoc = async ({data}) => {
  const { id, ...payload } = data;
  return await fireStore.collection('buzzs').doc(id).update(payload);
}

export const deleteDoc = async ({ id }) => {
  return await fireStore.collection('buzzs').doc(id).delete();
}